// extracted by mini-css-extract-plugin
export default {"background":"backgroundFader_background__T8J1a","blur":"backgroundFader_blur__KoPUA"};